import React, { useState, useEffect, useMemo } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import axios from 'axios';
import CommonTable from '../../../common/CommonTable';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL || 'http://127.0.0.1:8000/';

const Mainambulance = () => {
  const [filterData, setFilterData] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedMunicipalities, setSelectedMunicipalities] = useState([]);
  const [selectedSubMunicipalities, setSelectedSubMunicipalities] = useState([]);
  const [municipalities, setMunicipalities] = useState([]);
  const [subMunicipalities, setSubMunicipalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const typeOptions = [
    { name: '110', value: '110' },
    { name: '+670 331 1044', value: '+670 331 1044' }
  ];

  // Fetch municipalities
  useEffect(() => {
    axios
      .post(`${backendUrl}Municipalities/municipalities_list/`)
      .then((response) => response.data)
      .then((data) =>
        setMunicipalities(
          data.map((mun) => ({ name: mun.adm1, value: mun.adm1_code }))
        )
      )
      .catch((error) =>
        console.error('Error fetching municipalities:', error)
      );
  }, []);

  // Fetch submunicipalities based on selected municipalities
  useEffect(() => {
    if (selectedMunicipalities.length > 0) {
      axios
        .post(`${backendUrl}Municipalities/sub_municipalities_list/`, {
          adm2_code: selectedMunicipalities,
        })
        .then((response) => {
          setSubMunicipalities(
            response.data.map((sub) => ({
              name: sub.adm2,
              value: sub.adm2_code,
            }))
          );
        })
        .catch((error) =>
          console.error('Error fetching sub-municipalities:', error)
        );
    } else {
      setSubMunicipalities([]);
      setSelectedSubMunicipalities([]);
    }
  }, [selectedMunicipalities]);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setHasSearched(true);

    const filters = {
      type: selectedTypes,
      municipality: selectedMunicipalities,
      submunicipality: selectedSubMunicipalities,
    };

    try {
      const response = await axios.post(
        `${backendUrl}roadaccident/filter_ambulance_details/`,
        filters,
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (response.status === 200) {
        setFilterData(response.data);
      } else {
        console.error('Failed to fetch filtered data');
        setFilterData([]);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setFilterData([]);
      alert('Error fetching data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    { key: 'SlNo', label: 'S.No' },
    { key: 'type', label: 'Type', sortable: true },
    { key: 'municipality', label: 'Municipality', sortable: true },
    { key: 'submunicipality', label: 'Sub-Municipality', sortable: true },
    { key: 'suco', label: 'Suco', sortable: true },
    { key: 'location', label: 'Location' },
    { key: 'latitude', label: 'Latitude', align: 'right' },
    { key: 'longitude', label: 'Longitude', align: 'right' },
  ], []);

  return (
    <>
      <div className="formcontainer1">
        <Form onSubmit={handleSearch}>
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group controlId="formGroupType">
                <Form.Label className="labeltext" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                  Type
                </Form.Label>
                <MultiSelect
                  value={selectedTypes}
                  options={typeOptions}
                  onChange={(e) => setSelectedTypes(e.value)}
                  optionLabel="name"
                  placeholder="Select type(s)"
                  display="chip"
                  style={{ width: "250px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formGroupMunicipality">
                <Form.Label className="labeltext" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                  Municipality
                </Form.Label>
                <MultiSelect
                  value={selectedMunicipalities}
                  options={municipalities}
                  onChange={(e) => setSelectedMunicipalities(e.value)}
                  optionLabel="name"
                  placeholder="Select municipality(s)"
                  display="chip"
                  style={{ width: "250px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formGroupSubMunicipality">
                <Form.Label className="labeltext" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                  Sub-Municipality
                </Form.Label>
                <MultiSelect
                  value={selectedSubMunicipalities}
                  options={subMunicipalities}
                  onChange={(e) => setSelectedSubMunicipalities(e.value)}
                  optionLabel="name"
                  placeholder={
                    selectedMunicipalities.length > 0
                      ? 'Select sub-municipality(s)'
                      : 'Select municipality first'
                  }
                  disabled={selectedMunicipalities.length === 0}
                  display="chip"
                  style={{ width: "250px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Button variant="primary" type="submit" disabled={loading} style={{ marginTop: '30px', marginRight: '10px' }}>
                {loading ? "Searching..." : "Search"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      {hasSearched && (
        <div className="formcontainer1 mt-4">
          <CommonTable
            tableData={filterData}
            columns={columns}
            searchableKeys={['type', 'municipality', 'submunicipality', 'suco', 'location']}
            tableName="Ambulance_Directory"
            emptyMessage="No ambulance records found."
          />
        </div>
      )}
    </>
  );
};

export default Mainambulance;
